module.exports = __webpack_public_path__ + "static/media/battle-1846807_1280.3b4c8bfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/battle-1846807_1280.jpg
// module id = 580
// module chunks = 0